import { createNamespacedHelpers } from "vuex";

const { mapActions, mapGetters, mapState } = createNamespacedHelpers("error");

export default {
  computed: {
    ...mapState({
      errors: state => state.errors
    }),
    ...mapGetters(["getErrorList", "getErrors", "getCommonErrors"])
  },
  methods: {
    ...mapActions([
      "setErrors",
      "deleteErrors",
      "clearErrors",
      "clearCommonErrors",
      "deleteCommonErrors"
    ])
  }
};
